import Cookies from 'universal-cookie';
import { REGION_KEYS, VIEWPORT } from 'utils/constants';

const isMobile = window.innerWidth < VIEWPORT.TABLET_MAX;

function isRegion() {
    return REGION_KEYS.some(region => window.location.host.indexOf(region) !== -1);
}

const getQueryParams = str => {
    const paramStr =
        '{"' +
        decodeURI((str || '').substring(1))
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
        '"}';
    return JSON.parse(paramStr);
};

const formatDate = date => {
    const allMonths = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    const dateObj = new Date(date);
    const year = dateObj.getUTCFullYear();

    const month = allMonths[dateObj.getUTCMonth()];
    const day = dateObj.getUTCDate();
    const strDay = day < 10 ? `0${day}` : day;
    return `${month} ${strDay}, ${year}`;
};

const formatDateTime = date => {
    const formattedDate = formatDate(date);

    let options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };
    const timeString = new Date(date).toLocaleString('en-US', options);
    return `${formattedDate}, ${timeString}`;
};

const formatPhone = phoneNumberString => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = match[1] ? '+1 - ' : '';
        return [intlCode, match[2], '-', match[3], '-', match[4]].join('');
    }
    return null;
};

const setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
};

const removeLocalStorage = key => {
    localStorage.removeItem(key);
};

const removeTravAuthCookies = () => {
    const cookies = new Cookies();
    ['TravAuthE', 'TravAuthV', 'SMSESSION'].forEach(name => {
        cookies.remove(name, { domain: '.travelers.com', path: '/' });
    });
};

// export list in alphabetical order
export {
    formatDate,
    formatDateTime,
    formatPhone,
    getQueryParams,
    isMobile,
    isRegion,
    setLocalStorage,
    removeLocalStorage,
    removeTravAuthCookies
};
